import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { setTag } from '@sentry/react';
import { createContext, useCallback, useEffect, useState } from 'react';
import { teamAliasMappings } from '../data/TeamAliasMappings.js';
export var OwnershipContext = /*#__PURE__*/ createContext({
    backendOwner: null,
    framework: null,
    frontendOwner: null,
    update: function update() {
        return undefined;
    }
});
export var OwnershipProvider = function OwnershipProvider(param) {
    var children = param.children, defaultOwner = param.defaultOwner, defaultFramework = param.defaultFramework;
    var _teamAliasMappings_defaultOwner;
    var resolvedDefaultOwner = defaultOwner ? (_teamAliasMappings_defaultOwner = teamAliasMappings[defaultOwner]) !== null && _teamAliasMappings_defaultOwner !== void 0 ? _teamAliasMappings_defaultOwner : defaultOwner : null;
    var _useState = _sliced_to_array(useState({
        backendOwner: null,
        framework: defaultFramework !== null && defaultFramework !== void 0 ? defaultFramework : null,
        frontendOwner: resolvedDefaultOwner
    }), 2), _useState_ = _useState[0], backendOwner = _useState_.backendOwner, framework = _useState_.framework, frontendOwner = _useState_.frontendOwner, setOwnership = _useState[1];
    var update = useCallback(function(newOwnership) {
        var _teamAliasMappings_newOwnership_backendOwner, _teamAliasMappings_newOwnership_frontendOwner;
        var normalizedOwnership = {
            backendOwner: newOwnership.backendOwner ? (_teamAliasMappings_newOwnership_backendOwner = teamAliasMappings[newOwnership.backendOwner]) !== null && _teamAliasMappings_newOwnership_backendOwner !== void 0 ? _teamAliasMappings_newOwnership_backendOwner : newOwnership.backendOwner : null,
            framework: newOwnership.framework,
            frontendOwner: newOwnership.frontendOwner ? (_teamAliasMappings_newOwnership_frontendOwner = teamAliasMappings[newOwnership.frontendOwner]) !== null && _teamAliasMappings_newOwnership_frontendOwner !== void 0 ? _teamAliasMappings_newOwnership_frontendOwner : newOwnership.frontendOwner : null
        };
        setOwnership(normalizedOwnership);
    }, []);
    useEffect(function() {
        if (frontendOwner) {
            setTag('frontendOwner', frontendOwner);
        }
    }, [
        frontendOwner
    ]);
    return /*#__PURE__*/ _jsx(OwnershipContext.Provider, {
        value: {
            backendOwner: backendOwner,
            framework: framework,
            frontendOwner: frontendOwner,
            update: update
        },
        children: children
    });
};

//# sourceMappingURL=OwnershipContext.js.map